import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../../components'
import { INBOUND_APPOINTMENTS } from '../../../../navigation/constants'
import { boardLocale } from '../../../InboundAppointments/FranjaCapacityStrip'

const T = 'receiving_config.warnings'

export const PostSaveWarningsBanner = ({ warnings, onRevert, canRevert, onDismiss, warehouseId }) => {
  const { t, i18n } = useTranslation()
  const overbooked = warnings?.overbooked_dates || []
  const affected = warnings?.affected_appointments || 0
  if (overbooked.length === 0 && affected === 0) return null
  // The board (InboundAppointmentsBoardContainer) derives its date from
  // `pickedDate ?? todayInTimezone(warehouse.time_zone)` and reads no query parameter, so a
  // `?date=` here would be an inert deep link that does not exist. Link to the board path only
  // (same fix already applied in Task 10's ConflictsDialog.js).
  const board = INBOUND_APPOINTMENTS.replace(':warehouse_id', warehouseId)
  return (
    <div className="rounded-md bg-yellow-50 border border-yellow-300 text-yellow-900 px-4 py-3 text-sm space-y-2" role="alert">
      <div className="flex items-center justify-between">
        <span className="font-semibold">{t(`${T}.title`)}</span>
        <div className="flex gap-2">
          {canRevert && (
            <Button type="secondary" onClick={onRevert}>
              {t(`${T}.revert`)}
            </Button>
          )}
          <button type="button" className="text-yellow-800 hover:underline" onClick={onDismiss}>
            {t(`${T}.dismiss`)}
          </button>
        </div>
      </div>
      {affected > 0 && <p>{t(`${T}.affected_count`, { count: affected })}</p>}
      {overbooked.length > 0 && (
        <>
          <p>{t(`${T}.overbooked_intro`)}</p>
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left">
                <th className="py-1 pr-4">{t(`${T}.overbooked_headers.date`)}</th>
                <th className="py-1 pr-4">{t(`${T}.overbooked_headers.franja`)}</th>
                <th className="py-1 pr-4">{t(`${T}.overbooked_headers.reserved`)}</th>
                <th className="py-1 pr-4">{t(`${T}.overbooked_headers.capacity`)}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {overbooked.map(r => (
                <tr key={`${r.date}-${r.franja_id}`} className="border-t border-yellow-200">
                  <td className="py-1 pr-4">{r.date}</td>
                  <td className="py-1 pr-4">{r.franja_label}</td>
                  <td className="py-1 pr-4">{Number(r.reserved_units).toLocaleString(boardLocale(i18n))}</td>
                  <td className="py-1 pr-4">{Number(r.unit_capacity).toLocaleString(boardLocale(i18n))}</td>
                  <td className="py-1 text-right">
                    <Link to={board} className="text-indigo-700 hover:underline">
                      {t(`${T}.view_board`)}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  )
}
